import { ContentType } from '@/contentTypes';
import { AxiosPromise } from 'axios';
import axios from '@axios';
import qs from 'qs';
import { SearchResponse } from '@/types';

export async function search(searchString: string = ''): AxiosPromise<SearchResponse> {
    return axios.get(`/search?${qs.stringify({ q: searchString })}`);
}
